templates = require '../../client-templates'

module.exports = class Review
  constructor: ({@data, @uuid, @$el}) ->

  prepareData: ->
    return unless @data?.averageRating and @data.ratingCount

    rating = Math.round(@data.averageRating * 10) / 10
    bhc =
      rating: "review-rating:#{@uuid}_#{rating}"
      ratingCount: "rating-count:#{@uuid}_#{@data.ratingCount}"

    stars = []
    for position in [1..5]
      starType = switch
        when rating > 3 / 4
          'full-star'
        when rating > 1 / 4
          'half-star'
        else
          'empty-star'
      stars.push "<span class='#{starType}'></span>"
      rating--

    productRating:
      bhc: bhc
      count: I18n.toNumber @data.ratingCount
      stars: stars

  render: ->
    @$el.find('.deal-title').after templates.product_reviews.render(@prepareData())
